import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { whatsappLink } from '../utils/whatsapp';
export function FloatingWhatsApp() {
  const reduceMotion = useReducedMotion();
  return <div className="fixed bottom-5 right-4 z-50 flex items-center gap-3 sm:bottom-7 sm:right-7" data-id="element-60" data-mp="1d4c5f7xahpx">
      <span className="hidden rounded-full border border-gold/40 bg-ink/90 px-4 py-2 text-sm font-semibold text-gold-soft backdrop-blur sm:block" data-id="element-61" data-mp="3tigln121blgt">
        Escribime ahora
      </span>

      <a href={whatsappLink('Hola Maestro, necesito una consulta urgente.')} target="_blank" rel="noopener noreferrer" aria-label="Consultar ahora por WhatsApp" className="relative flex h-16 w-16 items-center justify-center rounded-full bg-wa text-[#062b12] shadow-[0_10px_40px_-6px_rgba(37,211,102,0.7)] transition-transform duration-150 ease-out hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-soft active:scale-95" data-id="element-62" data-mp="3jrc5hy0mhuke">
        {!reduceMotion && <motion.span aria-hidden="true" className="absolute inset-0 rounded-full bg-wa" animate={{
        scale: [1, 1.6],
        opacity: [0.5, 0]
      }} transition={{
        duration: 1.8,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-63" data-mp="3t6w15tt3kauk" />}
        <MessageCircleIcon className="relative h-8 w-8" aria-hidden="true" data-id="element-64" data-mp="b0zsfgzgxpg8" />
      </a>
    </div>;
}